/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "layout",
    staticStyle: {
      "height": "100%"
    },
    on: {
      "touchmove": _vm.touchFalse,
      "touchstart": _vm.touchstart,
      "touchend": _vm.touchend
    }
  }, [_c('view-box', {
    ref: "viewBox",
    attrs: {
      "body-padding-bottom": 0
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": _vm.keepAliveList
    }
  }, [_c('router-view')], 1)], 1), _c('BottomBar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isInMain && _vm.showHomebottomBar,
      expression: "isInMain && showHomebottomBar"
    }],
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };